import ZaiaInputForm from "./ZaiaInputForm";

export default ZaiaInputForm;